export const FRAUD_STATUS_COLOR: Record<string, string> = {
  Success: "success",
  Failed: "error",
  Pending: "warning",
};

export interface FraudDetectionDevice {
  os: string;
  ipCity: string;
  browser: string;
  deviceId: string;
  ipAddress: string;
  ipCountry: string;
  userAgent: string;
  deviceType: string;
  torDetected: boolean;
  vpnDetected: boolean;
  proxyDetected: boolean;
}

export interface FraudDetectionMonetaryTransaction {
  depositId: string;
  depositAmount: string;
  depositStatus: string;
  paymentMethod: string | null;
}

export interface FraudDetectionUser {
  note: string | null;
  email: string;
  phone: string;
  leadId: string;
  clickId: string | null;
  country: string;
  devices: FraudDetectionDevice[];
  language: string;
  lastName: string;
  timezone: string | null;
  firstName: string;
  utmSource: string | null;
  campaignId: string | null;
  leadSource: string;
  affiliateId: string | null;
  landingPage: string;
  utmCampaign: string | null;
  affiliateName: string | null;
  affiliateEmail: string | null;
  duplicateUsers: unknown[];
  voipCallRecords: unknown[];
  registrationTime: string;
  monetaryTransactions: FraudDetectionMonetaryTransaction[];
}

export interface FraudDetectionRequestData {
  user: FraudDetectionUser;
  isAdvanced: boolean;
}

export interface MarketPlaceFraudDetection {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  createdBy: string;
  updatedBy: string;
  userId: string;
  customerId: string;
  requestData: FraudDetectionRequestData;
  responseData: Record<string, unknown> | null;
  status: string;
  error: string | null;
  score: number | null;
  summary: string | null;
  decision: string | null;
  riskBreakdown: Record<string, unknown> | null;
}

export type MarketPlaceFraudDetectionInput = Pick<
  MarketPlaceFraudDetection,
  | "userId"
  | "customerId"
  | "requestData"
  | "status"
  | "score"
  | "summary"
  | "decision"
  | "error"
  | "responseData"
  | "riskBreakdown"
>;

export const FRAUD_DETECTION_STATUS_OPTIONS = [
  "Pending",
  "Success",
  "Failed",
] as const;
